export const PAGE_TYPES = {
  appointment: 'appointment',
  review: 'review',
}
